 import React from "react";
import { getDefaultMaxLength } from "../../../../utils/length";
import useAutoExpandTextarea from "../../../../hooks/useAutoExpandTextarea";

import "./textarea.scss";
const TextArea = ({
  input,
  meta: { touched, error },
  meta,
  type,
  label,
  required,
  placeholder,
  notification,
  disabled,
  rows = 2,
  withCounters,
  maxLength,
}) => {
  // Auto-expand textarea hook
  const textareaRef = useAutoExpandTextarea(input.value, 60);
  return (
    <>
      <div className={`formField textArea ${input.value ? "fill" : ""}`}>
        {label && <label className={required && "required"}>{label} :</label>}
        {(meta.active || touched || input.value !== "") && input.value && (
          <label className="inputLabel">{placeholder}</label>
        )}
        <textarea
          {...input}
          ref={textareaRef}
          placeholder={placeholder}
          onChange={input.onChange}
          type={type}
          value={input.value}
          disabled={disabled}
          className='areaWithCounters'
          maxLength={maxLength || getDefaultMaxLength(maxLength)}
          rows={rows}
          style={{ resize: "none", minHeight: "60px", transition: "height 0.1s ease" }}
        />
        {(withCounters || maxLength) && (
          <div className='symbolCounters'>{input.value ? input.value.length : 0} / {maxLength || getDefaultMaxLength(maxLength)}</div>
        )}
        {touched && error && (
          <p className="formItemError">{touched && error}</p>
        )}
      </div>
    </>
  );
};

export default TextArea;
